import { gql } from 'graphql-request'

export const favouriteMutation = () => gql`
  mutation ($id: String!) {
    toggleFavourite(id: $id) {
      success
      reason
    }
  }
`

